import React, { createContext, useContext, useEffect } from 'react';

const ScrollContext = createContext();

export function useScroll() {
    return useContext(ScrollContext);
}

export function ScrollProvider({ children }) {
    const scrollToElement = (elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
            const currentHash = window.location.hash.replace('#', '');

            if (currentHash !== elementId) {
                window.location.hash = `#${elementId}`; // ✅ корректно обновляет URL
            } else {
                // если уже на этом же hash, "встряхнем" его:
                window.location.hash = '';
                setTimeout(() => {
                    window.location.hash = `#${elementId}`;
                }, 0);
            }

            setTimeout(() => {
                element.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    };

    // Скроллим при первой загрузке, если есть hash в URL
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const id = hash.replace('#', '');
            scrollToElement(id);
        }
    }, []);

    return (
        <ScrollContext.Provider value={scrollToElement}>
            {children}
        </ScrollContext.Provider>
    );
}
